import { useMutation } from '@tanstack/react-query'
import { newsletterService } from '@/lib/api/services/newsletter'
import type { NewsletterSubscribeRequest } from '@/lib/api/types'
import type { ApiResponse, NewsletterSubscription } from '@/lib/api/types'

// Query keys factory
export const newsletterKeys = {
  all: ['newsletter'] as const,
  subscriptions: () => [...newsletterKeys.all, 'subscriptions'] as const,
}

/**
 * Hook to subscribe to newsletter
 */
export const useSubscribeNewsletter = () => {
  return useMutation<
    ApiResponse<NewsletterSubscription>,
    Error,
    NewsletterSubscribeRequest
  >({
    mutationFn: (data: NewsletterSubscribeRequest) =>
      newsletterService.subscribe(data),
  })
}

